import { Typography, CircularProgress, Grid, Chip } from "@material-ui/core";
import { Breadcrumb } from "components/breadCrumb";
import { PageTitle } from "components/pageTitle";
import React, { useEffect } from "react";
import { useParams } from "react-router";
import { Wrapper } from "components/wrapper";
import { DetailCard, DetailField, DetailSectionTitle } from "components/detailPage";
import { DocumentList } from "components/documentList";
import { ExportButtons } from "components/exportButtons";
import { usePrestacaoContasDetailsState } from "./context/prestacao-contas-details-context";
import { usePrestacaoContasDetailsController } from "./context/prestacao-contas-details-controller";
import { formatPeriodo } from "pages/prestacaoContas/prestacaoContasTable.component";

const formatDate = (value?: string | null) =>
  value ? new Date(value).toLocaleDateString('pt-BR') : '-';

export function PrestacaoContasDetailsPage() {
  const { prestacaoContasDetails, loading, error } = usePrestacaoContasDetailsState();
  const { loadPrestacaoContasDetails, clearPrestacaoContasDetails, exportPrestacaoContasDetail } = usePrestacaoContasDetailsController();
  let { id } = useParams<{ id: string }>();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    if (id) {
      loadPrestacaoContasDetails(parseInt(id));
    }

    return () => {
      clearPrestacaoContasDetails();
    };
  }, [id, loadPrestacaoContasDetails, clearPrestacaoContasDetails]);

  if (loading) {
    return (
      <Wrapper>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
          <CircularProgress />
        </div>
      </Wrapper>
    );
  }

  if (error) {
    return (
      <Wrapper>
        <Typography color="error" variant="h6">{error}</Typography>
      </Wrapper>
    );
  }

  if (!prestacaoContasDetails) {
    return (
      <Wrapper>
        <Typography variant="h6">Registro não encontrado.</Typography>
      </Wrapper>
    );
  }

  return (
    <>
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Planejamento e Prestação de Contas", href: "/prestacao-contas" },
          { label: prestacaoContasDetails.tipoDocumentoPrestacaoContasName },
        ]}
      />
      <PageTitle>{prestacaoContasDetails.tipoDocumentoPrestacaoContasName}</PageTitle>
      <Wrapper>
        <ExportButtons onExport={(format) => exportPrestacaoContasDetail(Number(id), format)} />
        <DetailCard>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Chip
                label={prestacaoContasDetails.indStatus === 2 ? 'Finalizado' : 'Em Execução'}
                color={prestacaoContasDetails.indStatus === 2 ? 'primary' : 'default'}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <DetailField label="Período" value={formatPeriodo(prestacaoContasDetails.indPeriodicidade, prestacaoContasDetails.ano, prestacaoContasDetails.periodo, prestacaoContasDetails.anoFim)} />
            </Grid>
            <Grid item xs={12} sm={4}>
              <DetailField label="Data de Publicação" value={formatDate(prestacaoContasDetails.dtaPublicacao)} />
            </Grid>

            <Grid item xs={12}>
              <DetailSectionTitle>Descrição</DetailSectionTitle>
            </Grid>

            <Grid item xs={12}>
              <DetailField label="Descrição" value={prestacaoContasDetails.textoDescricao} />
            </Grid>

            <Grid item xs={12}>
              <DetailSectionTitle>Documentos</DetailSectionTitle>
              <DocumentList documents={prestacaoContasDetails.documentos} />
            </Grid>
          </Grid>
        </DetailCard>
      </Wrapper>
    </>
  );
}
